/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Common filter properties for tours across carrier and consignee roles
 */
export enum ToursFilterProperties {
  Status = 'status',
  TourNumber = 'tourNumber',
  ExternalTourName = 'externalTourName',
  CarrierKey = 'carrierKey',
  DateClosed = 'dateClosed',
  DateCreated = 'dateCreated',
  CheckoutDate = 'checkoutDate'
}
